export default __webpack_public_path__ + "static/media/NodeJS.ab25a8c5.pdf";